<template>
    <div id="card">
        <div class="d-flex flex-column h-50">
            <span>{{ title }}</span>
            <span>{{ total }}</span>
        </div>
        <v-icon size="27" > {{ icon }} </v-icon>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: true,
            },
            total: {
                type: Number,
                required: true,
            },
            icon: {
                type: String,
                default: ''               
            }
        },
    };
</script>
<style>
    #card {
       display: flex;
       flex-direction: row; 
       align-items: center;
       border: 1px solid #AAA;
       border-left: 3px solid red;
       border-radius: 7px;
       height: 7vw;
       justify-content: space-evenly;
       align-content: space-around;
       box-shadow: 0px 1px 18px -12px #607D8B;
       @media (max-width: 768px){
        height: 10vw;
       }
    }
</style>